import React, { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Dialog } from "../inbox/InboxDialogs";

export default function LitigeAvocatDialog({ sav, onClose, onSent }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/litiges/${sav.id}/avocat-draft`).then((r) => setD(r.data)).catch(() => onClose()); }, [sav.id, onClose]);
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/litiges/${sav.id}/send-avocat`, { to: d.to, subject: d.subject, body: d.body });
      toast.success(r.data.simulated ? "Envoi simulé (rien n'est parti) — litige « Transmis à l'avocat »" : "Dossier transmis à l'avocat");
      onSent(); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  const set = (k) => (e) => setD({ ...d, [k]: e.target.value });
  return (
    <Dialog title="Transmettre le litige à l'avocat" onClose={onClose} testid="litige-avocat-dialog"
      footer={<><button onClick={onClose} className="btn-ghost text-sm">Annuler</button>
        <button onClick={send} disabled={busy || !d?.to} className="btn-primary text-sm" data-testid="litige-avocat-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer</button></>}>
      {!d ? <Loader2 className="w-5 h-5 animate-spin" /> : (
        <div className="space-y-2 text-sm">
          {d.no_email && <div className="text-xs text-amber-700" data-testid="litige-avocat-no-email">Aucun email pour l'avocat choisi : complétez la fiche (Annuaire → Avocats) ou saisissez l'adresse.</div>}
          <input className="input-field w-full" placeholder="Email de l'avocat" value={d.to} onChange={set("to")} data-testid="litige-avocat-to" />
          <input className="input-field w-full" value={d.subject} onChange={set("subject")} data-testid="litige-avocat-subject" />
          <textarea className="input-field w-full min-h-[300px] font-mono text-xs" value={d.body} onChange={set("body")} data-testid="litige-avocat-body" />
          {d.simulation && <div className="text-[11px] text-norea-textMuted">Mode simulation : l'envoi est enregistré dans l'historique mais rien ne part.</div>}
        </div>
      )}
    </Dialog>
  );
}
